import {useRef} from 'react';
import {cn, SearchInput, useSearchInput} from '@chekin/guestapp-ui-kit';
import {useInfiniteFetchCompatibleDevices} from 'hooks/esim/useInfiniteFetchCompatibleDevices';
import {useTranslation} from 'react-i18next';
import {useScrollToBottom} from 'hooks/useScrollToBottom';
import {Skeleton} from '@chekinapp/ui';

type Props = {
  className?: string;
  os: 'ios' | 'android';
};
export const DeviceList = ({className, os}: Props) => {
  const {t} = useTranslation();
  const {innerValue, handleChange, reset} = useSearchInput({value: ''});
  const {data, isLoading, isFetchingNextPage, fetchNextPage, hasNextPage} =
    useInfiniteFetchCompatibleDevices({query: innerValue, os});

  const containerRef = useRef<HTMLUListElement>(null);
  useScrollToBottom({
    containerRef,
    onScrollToBottom: () => {
      if (hasNextPage) {
        fetchNextPage();
      }
    },
  });

  return (
    <div className="flex flex-col gap-6">
      <SearchInput
        className="w-full"
        value={innerValue}
        onChange={handleChange}
        placeholder={t('search')}
        onReset={reset}
      />
      <ul
        className={cn(
          'list-disc list-inside text-sm leading-6 marker:text-[0.8rem] max-h-[200px] overflow-y-auto',
          className,
        )}
        ref={containerRef}
      >
        {data?.pages
          .flatMap(page => page.results)
          .map(device => (
            <li key={device.id}>{device.name}</li>
          ))}
        {(isFetchingNextPage || isLoading) && (
          <>
            <Skeleton className="h-[16px] max-w-40 mt-2 bg-gray-200 rounded" />
            <Skeleton className="h-[16px] max-w-32 mt-2 bg-gray-200 rounded" />
            <Skeleton className="h-[16px] max-w-48 mt-2 bg-gray-200 rounded" />
            <Skeleton className="h-[16px] max-w-16 mt-2 bg-gray-200 rounded" />
            <Skeleton className="h-[16px] max-w-48 mt-2 bg-gray-200 rounded" />
            <Skeleton className="h-[16px] max-w-40 mt-2 bg-gray-200 rounded" />
            <Skeleton className="h-[16px] max-w-16 mt-2 bg-gray-200 rounded" />
            <Skeleton className="h-[16px] max-w-48 mt-2 bg-gray-200 rounded" />
            <Skeleton className="h-[16px] max-w-32 mt-2 bg-gray-200 rounded" />
            <Skeleton className="h-[16px] max-w-16 mt-2 bg-gray-200 rounded" />
          </>
        )}
      </ul>
    </div>
  );
};
